import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    handleError(error: any): void {
        console.log('Global Error Encountered', error);
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;
        if (chunkFailedMessage.test(error.message)) {
            // if (confirm('New version available. Load New Version?')) {
            console.log('New version of chunk available. Loading New Version!', window.location);
            window.location.reload();
            // }
        }
    }
}
